// 🤖 AUTO-GENERATED from data/components.json
// DO NOT EDIT MANUALLY - Changes will be overwritten
// Schema version: 1.0.0

import type { VoltraBaseProps } from '../baseProps'

export type TextProps = VoltraBaseProps & {
  /** Maximum number of lines to display */
  numberOfLines?: number
  /** Text alignment for multiline text */
  multilineTextAlignment?: 'left' | 'center' | 'right' | 'auto'
}
